import React, { useCallback } from 'react';

import { Checkbox, Stack } from '@lyearn/ui';

import { StaffRoleWithRoleProfileFragment } from '../../graphql/fragments/generated/StaffRoleWithRoleProfile';
import StaffRoleItem from '../StaffRoleItem';

interface ListItemProps {
  staffRole: StaffRoleWithRoleProfileFragment;
  selected?: boolean;
  onSelect: (roleId: string) => void;
  disabled?: boolean;
}

function ListItem(props: ListItemProps) {
  const { staffRole, onSelect, selected, disabled } = props;

  const _onSelect = useCallback(() => {
    if (disabled) {
      return;
    }
    onSelect(staffRole.id);
  }, [disabled, onSelect, staffRole.id]);

  return (
    <Stack
      alignItems="center"
      className="border-b border-divider py-16 ps-16 pe-20"
      justifyContent="between"
      role="button"
      onClick={_onSelect}>
      <StaffRoleItem staffRole={staffRole} />
      <Checkbox checked={selected} disabled={disabled} />
    </Stack>
  );
}

export default ListItem;
